import { createContext, useEffect, useState } from 'react';

export const ThemeContext = createContext('light');
export const THEME_KEY = 'ostrum-portal-theme';

function initialTheme() {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch { /* A blocked storage setting must not prevent the portal from loading. */ }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function usePortalTheme() {
  const [theme, setTheme] = useState(initialTheme);
  useEffect(() => {
    // Swagger's native dark palette includes dialogs, schema trees, and form controls.
    const root = document.documentElement;
    const previousDark = root.classList.contains('dark-mode');
    const previousScheme = root.style.colorScheme;
    root.classList.toggle('dark-mode', theme === 'dark');
    root.style.colorScheme = theme;
    try { localStorage.setItem(THEME_KEY, theme); } catch { /* Theme still works without storage. */ }
    return () => {
      root.classList.toggle('dark-mode', previousDark);
      root.style.colorScheme = previousScheme;
    };
  }, [theme]);
  return [theme, () => setTheme(current => current === 'dark' ? 'light' : 'dark')];
}
